////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, findIndex, map } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const scheduledPricesManager = {
	[ActionsTypes.GET_SCHEDULED_PRICES]: (state) =>
		update(state, {
			scheduledPricesManager: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.GET_SCHEDULED_PRICES_SUCCESS]: (state, payload) => {
		let payloadFiltersCP = cloneDeep(payload.data.headerParam.filters)
		const paging = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
		}

		const arr = map(payload.data.headerContent.contentPagined.content, (e, k) => {
			// For test
			/*if (!payload.toggledLines) {
				if (k === 0) e.priceCampaignLines = null
				else e.priceCampaignLines = ''
			}*/

			if (payload.toggledLines) {
				e.toggleNested = true
			}
			return e
		})

		return update(state, {
			scheduledPricesManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: arr,
				},
				paging: {
					$set: paging,
				},
				header: {
					$set: payloadFiltersCP,
				},
			},
		})
	},
	[ActionsTypes.GET_SCHEDULED_PRICES_FAILURE]: (state, payload) =>
		update(state, {
			scheduledPricesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_TRANSMISSION]: (state) =>
		update(state, {
			scheduledPricesManager: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.GET_TRANSMISSION_SUCCESS]: (state, payload) => {
		return update(state, {
			scheduledPricesManager: {
				isLoading: {
					$set: false,
				},
				transmission: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.GET_TRANSMISSION_FAILURE]: (state, payload) =>
		update(state, {
			scheduledPricesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_PRICE_CAMPAIGN_NESTED_LINES]: (state) =>
		update(state, {
			scheduledPricesManager: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.GET_PRICE_CAMPAIGN_NESTED_LINES_SUCCESS]: (state, payload) => {
		const scheduledPricesItems = cloneDeep(state.scheduledPricesManager.items)

		const fIndex = findIndex(scheduledPricesItems, { id: payload.data.id })
		if (fIndex > -1) {
			scheduledPricesItems[fIndex] = payload.data
			scheduledPricesItems[fIndex].toggleNested = true
		}
		return update(state, {
			scheduledPricesManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: scheduledPricesItems,
				},
			},
		})
	},
	[ActionsTypes.GET_PRICE_CAMPAIGN_NESTED_LINES_FAILURE]: (state, payload) =>
		update(state, {
			scheduledPricesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_SCHEDULED_PRICES_MANAGER_ITEMS]: (state, _payload) => {
		return update(state, {
			scheduledPricesManager: {
				items: {
					$set: [],
				},
			},
		})
	},
}

export default scheduledPricesManager
